import React from "react"
import CalendarCard from "./CalendarCard"
import { useStaticQuery, graphql } from "gatsby"
import { motion } from "framer-motion";
import { springVariants, opacityVariants, springViewport } from '../utils/framerVariants';

const CalendarFeed = ({ articles }) => {
    return (
      <motion.div
        variants={springVariants}
        initial="invisible"
        whileInView="visible"
        viewport={springViewport}
        className="grid grid-cols-1 feed">
        {articles.map((article) => (
          <CalendarCard article={article || []} key={`${article.slug}`} />
        ))}
      </motion.div>
    )
  }

export default CalendarFeed
